import { Flame, Info, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { StarIcon } from "./StarIcon";

interface StatCardProps {
  icon: React.ElementType;
  label: string;
  value: string | number;
  color: string;
  popover?: string;
}

function StatCard({ icon: Icon, label, value, color, popover }: StatCardProps) {
  return (
    <Card className="group">
      <CardContent className="relative p-6">
        <div className="flex items-center space-x-4">
          <div className={cn(
            "p-3 rounded-xl transition-all duration-300 group-hover:scale-110",
            color
            // `bg-${color}-500/10 text-${color}-500`
          )}>
            <Icon className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground font-medium">{label}</p>
            <p className="text-2xl font-bold text-foreground">{"" + value}</p>
          </div>
        </div>
        {
          popover && <Popover>
            <PopoverTrigger asChild>
              <Info className="absolute top-4 right-4 text-foreground" />
            </PopoverTrigger>
            <PopoverContent side="top" collisionPadding={24}>
                {popover}
            </PopoverContent>
          </Popover>
        }
      </CardContent>
    </Card>
  );
}

export function GameStats({ balance, sparkles, dailyStreak }: { balance: number, sparkles: string, dailyStreak: number }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <StatCard
        icon={Scale}
        label="Din balans"
        value={balance}
        color="bg-green-500/10 text-green-500"
        popover="Din balans baseras på ett vägt snitt av dina senaste inmatningar i uppskattad balans."
      />

      <StatCard
        icon={StarIcon}
        label="Uppnådda nivåer"
        value={sparkles}
        color="bg-[#ebc302]/15"
        popover="Uppnådda nivåer är antal underrubriker du har jobbat igenom."
      />

      <StatCard
        icon={Flame}
        label="Dagar i följd"
        value={dailyStreak}
        color="bg-orange-500/10 text-orange-500"
        popover="Dagar i följd är antalet dagar i rad som du har använt appen."
      />
    </div>
  );
}